import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'
import { getRandomInt, trace } from 'rytm-helpers'

export const initSmBg = () => {
  const bg = document.querySelector(".home-bg")
  const list = [...bg.querySelectorAll("img")]
  // list.forEach( initBgImg )
}

const initBgImg = (img, index) => {
  TweenMax.killTweensOf(img)
  const time = getRandomInt(30, 70) * .1
  const wW = window.innerWidth
  const wH = window.innerHeight
  const maxX = index == 0 ? wW * 0.023 : wW * 0.012
  const maxY = index == 0 ? wH * 0.047 : wH * 0.02
  const x = - getRandomInt(10, maxX)
  const y = getRandomInt(10, maxY)
  TweenMax.to(img, time, { x, y, repeat: -1, yoyo: true, ease: Power1.easeInOut})
}